module.exports = __webpack_public_path__ + "img/DE01099.5c0bb92e.png";